import{jsx as o}from"react/jsx-runtime";import r from"@heroicons/react/24/outline/GlobeAltIcon";const t=({style:t})=>/*#__PURE__*/o(r,{style:{color:"var(--privy-color-error)",...t}});export{t as GlobeError};
